var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","color":"#fff","font-size":"2.4rem","padding":"2rem 0"}},[_c('div',{staticStyle:{"width":"100%","display":"flex","align-items":"center","padding":"1rem 0 2rem 0"}},[_c('span',{staticStyle:{"color":"#f30"}},[_vm._v("*")]),_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }